module.exports = __webpack_public_path__ + "img/page-translate@2x.fe589446.png";